import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type CopyText from './copy-text.vue'

export const copyTextProps = buildProps({
  clickText: {
    type: String,
    default: '点击复制',
  },
  copySucceed: {
    type: String,
    default: '已复制到剪切板',
  },
  value: {
    type: String,
    default: '',
  },
  // 复制成功图标
  iconName: {
    type: String,
    default: 'icon-succeed',
  },
  // 图标颜色
  iconColor: {
    type: String,
    default: '#fff',
  },
} as const)

// props
export type CopyTextProps = ExtractPropTypes<typeof copyTextProps>

// instance
export type CopyTextInstance = InstanceType<typeof CopyText>
